import dynamic from "next/dynamic";

export const DynamicContent049 = dynamic(() => import("./Content049"), {
  suspense: true,
});
